<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>运单</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
    </div>
    <div>
      <span>
        <!-- <div style="width:60%;display: flex;justify-content: space-between;margin:10px 10px 10px 10px;">
          <span >计划编号：<span>{{jiHuaBianHao}}</span></span>
          <span >计划日期：<span>{{planTime}}</span></span>
          <span >计划状态：<span class="red">{{planStatusShow}}</span></span>
        </div> -->
        <div class="addinpBox">
                <el-table
                  :data="tableData"
                  ref="table"
                  border
                  bordersize="mini"
                  style="width:100%;margin-top:10px;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column prop="customerName" label="客户名称"  align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="contractNo"   label="合同编号" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="flowtoType" label="流向" align="center"  show-overflow-tooltip>
                    <template slot-scope="scope"><div>
                        <span v-if="scope.row.flowtoType == '1'">外发</span>
                        <span v-if="scope.row.flowtoType == '2'">集港</span>
                        <span v-if="scope.row.flowtoType == '3'">倒中钢库</span>
                        <span v-if="scope.row.flowtoType == '4'">倒兴泰库</span>
                      </div></template>
                  </el-table-column>
                  <el-table-column property="canpayWeight" label="已开交货"  align="center" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="totalAllowOut" label="出货量" align="center" :formatter="emptyFn"></el-table-column>
                  <!-- 已开交货-出货量 = 未完成 -->
                  <el-table-column prop="" label="未完成"  align="center" :formatter="emptyFn">
                    <template slot-scope="scope">
                      <span>{{(scope.row.canpayWeight - scope.row.totalAllowOut).toFixed(3)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column property="inventoryWeight" label="可发库存"  align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="planWeight" label="可装配" align="center"  :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="allData4"  label="完成率（%）" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="planStatus" label="状态" align="center" >
                    <!-- 1未完成  2已完成 -->
                    <template slot-scope="scope"><div>
                      <span v-if="scope.row.planStatus=='1'">未完成</span>
                      <span v-if="scope.row.planStatus=='2'">已完成</span>
                      </div></template>
                  </el-table-column>
                  <el-table-column prop="createTime"  label="创建时间" align="center" width="180" :formatter="emptyFn">
                    <template slot-scope="scope">
                      <span>{{scope.row.createTime | dateFormat}}</span>
                    </template>
                  </el-table-column>
                </el-table>
        </div>
      </span>
      <!--运单情况-->
    <div>
      <span>
          <div style="display: flex;justify-content: space-between;">
          <div class="titleText">
              运单详情：
          </div>
          <div>
            <!-- 之前把新增派车和撤销派车两个按钮加到派车管理菜单下 -->
              <!-- <el-button type="primary" size="mini" @click="addPaiChe" btnCode='00DP002B005' v-if="addBtnShow && btnFlg[0]">新增派车</el-button> -->
              <!-- <el-button type="primary" size="mini" @click="cheXiaoClick" btnCode='00DP002B006' v-if="cheXiaoBtnShow && btnFlg[1]">撤销派车</el-button> -->
              <el-button type="primary" size="mini" @click="addPaiChe" btnCode='00DP001B00E' v-if="addBtnShow && btnFlg[0]">新增派车</el-button>
              <el-button type="primary" size="mini" @click="cheXiaoClick" btnCode='00DP001B00F' v-if="cheXiaoBtnShow && btnFlg[1]">撤销派车</el-button>
              
          </div>
          </div>
        <div class="addinpBox">
                  <!-- :summary-method="getSummaries"
                  show-summary -->
                <el-table
                  :data="paiCheXiangQingTab"
                  ref="paiCheXiangQingTab"
                  border
                  bordersize="mini"
                  @row-click = 'handleRowClick'
                  style="width:100%;margin-top:10px;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column prop="waybillNo"    label="运单号" align="center" width="200" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="vehicleNo"   label="车号" align="center"  width="120"></el-table-column>
                  <el-table-column prop=""   label="装车明细" align="center"  width="120">
                    <template slot-scope="scope"><div>
                        <el-button @click="handleClick(scope.row)" type="text" size="small" btnCode='00DP001B00O' v-if="btnFlg[2]">查看</el-button>
                      </div></template>
                  </el-table-column>
                  <el-table-column property="fleetName" label="车队"  align="center" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column property="driverName" label="司机"  align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column property="theorySuttle" label="理重"  align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column property="realSuttle" label="实重"  align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="warehouseName" label="指派垛位" align="center"  width="180" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="sendcatTime" label="派车时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="firsttareTimeShow" label="一检时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="startloadTime" label="装车开始时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="lockTimeShow" label="装车完成时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="suttleTimeShow" label="二检时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="lockTimeShow" label="完成时间" align="center" width="180" :formatter="emptyFn"></el-table-column>
                  <el-table-column property="waybillStatusShow" label="状态"  align="center" width="150" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="flowtoType" label="流向" align="center" width="140" show-overflow-tooltip>
                    <!-- <template slot-scope="scope">
                      <span v-if="scope.row.flowtoType == '1'">外发</span>
                      <span v-if="scope.row.flowtoType == '2'">集港</span>
                      <span v-if="scope.row.flowtoType == '3'">倒中钢库</span>
                      <span v-if="scope.row.flowtoType == '4'">倒兴泰库</span>
                    </template> -->
                  </el-table-column>
                  <el-table-column prop="name" label="到货凭证" align="center">
                    <template slot-scope="scope"><div>
                        <el-button type="text" size="mini" @click="seeImgClick(scope.row)" btnCode='00DP001B00P' v-if="btnFlg[3]">查看</el-button>
                      </div></template>
                  </el-table-column>
                </el-table>
                <!-- 分页 10,25,50,100-->
                <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="xiangQingPageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="xiangQingPageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total2">
                  </el-pagination>
                </div>
        </div>
      </span>
    </div>
    <!--点击查看-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="seeMark"
    width="900px"
    center>
      <span>
        <div class="addinpBox">
                <el-table
                  :data="seetableList"
                  ref="table"
                  border
                  bordersize="mini"
                  style="width:90%;margin-top:10px;margin-left:4%;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column prop="contractNo"    label="合同号" align="center" width="120"></el-table-column>
                  <el-table-column prop="deliverNo"   label="交货单号" align="center"  ></el-table-column>
                  <el-table-column property="materielCode" label="物料号"  align="center" ></el-table-column>
                  <el-table-column prop="plateId"    label="板序号" align="center" ></el-table-column>
                  <el-table-column property="plateNum" label="数量"  align="center" ></el-table-column>
                  <el-table-column prop="theoretWeight"    label="理重（吨）" align="center" ></el-table-column>
                  <el-table-column property="actualWeight" label="过磅（吨）"  align="center" ></el-table-column>
                  <el-table-column prop="materielSpec"    label="规格" align="center" ></el-table-column>
                </el-table>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="heTongQuXiaoClick" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
    <!--撤销派车弹框-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="cheXiaoMark"
    width="500px"
    center>
      <span>
        <div class="addinpBox">
            <el-input type="textarea" v-model="cheXiaoYuanYin" placeholder="请输入撤销原因"></el-input>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary"  size='mini' @click="cheXiaoQueDing">确定</el-button>
        <el-button  size='mini' @click="cheXiaoQuXiao" >取消</el-button>
      </span>
    </el-dialog>
    <!-- 到货凭证 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="imgMark"
    width="500px"
    center>
      <span>
        <div class="" v-for="(item,ix) in srcList2" :key="ix" style="width:150px;height:150px;margin:0 auto;">
          <el-image
              fit="cover"
              :src="item"
              style="width:100%;height:100%;"
              :preview-src-list="getSrcList2()"
            />
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgMark = false" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
    </div>

  </div>
</template>
<script>
import {
  wayBillList, // 派车详情
  yunDanGuanLiXiangQing, // 查看弹框数据
  cheXiaoPaiChe, // 撤销派车
  getManualDispatchCarInfo,
  receiptImg// 到货凭证
} from '@/api/zhb'
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP001B00E', '00DP001B00F','00DP001B00O','00DP001B00P'],
      title: '',
      h: '500px',
      total: 0,
      value: '',
      tableData: [],
      tableList: [],
      paiCheXiangQingTab: [], // 派车详情列表数据
      // 计划编号
      jiHuaBianHao: '',
      planTime:'',
      planStatusShow:'',
      // 合同号
      contractNo: '',
      // 查看
      seeMark: false,
      seetableList: [],
      heTongFrom: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      xiangQingPageNo: 1,
      xiangQingPageSize: 10,
      total2: 0,
      // 撤销
      cheXiaoMark: false,
      cheXiaoYuanYin: '',
      yunDanId: '',
      waybillStatus: '', // 车辆状态
      addBtnShow: true, // 新增按钮显示隐藏
      cheXiaoBtnShow: true, // 撤销派车按钮显示隐藏
      completeRate: '', // 完成率
      planStatus: '', // 状态
      contractNos: [],
      rowData:{},
      srcList2:[],
      imgMark:false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.rowData = JSON.parse(localStorage.getItem('rowData'))
      // this.rowData = this.$route.params.rowData
      this.jiHuaBianHao = this.rowData.planNo
      this.contractNo = this.rowData.contractNo
      this.planTime = this.rowData.collectPlanTime
      this.planStatusShow = this.rowData.planStatusShow
      this.completeRate = this.rowData.completeRate
      this.planStatus = this.rowData.planStatus
      if (this.completeRate == '100' || this.planStatus > '4' || this.rowData.flowtoType == '1') {
        this.cheXiaoBtnShow = false
        this.addBtnShow = false
      } else {
        this.cheXiaoBtnShow = true
        this.addBtnShow = true
      }
      this.tableData.push(this.rowData)
      console.log(this.tableData[0].flowtoType,'33333')
      this.getPaiCheXiangQingData()
    })
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/planManagement')
  },
  filters: {
    // arrayToStr(array){
    //   if (array==null ||array==undefined||array.length==0) {
    //     return '-'
    //   }else{
    //     let str=''
    //     array.forEach((item,index) => {
    //       str+=item
    //       if (index!=array.length-1) {
    //         str+=','
    //       }
    //     })
    //     return str
    //   }
    // }
  },
  methods: {
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 获取派车详情列表数据
    getPaiCheXiangQingData () {
      wayBillList({
        contractNo: this.contractNo, // 合同号
        planNo: this.jiHuaBianHao, // 计划编号
        pageNo: this.xiangQingPageNo,
        pageSize: this.xiangQingPageSize,
        flowtoType:this.rowData.flowtoType,
        weightFlg:this.rowData.weightFlg
      }).then(res => {
        this.paiCheXiangQingTab = res.list
        this.total2 = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      // this.getSearchData()
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.seeMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.xiangQingPageSize = val
      this.getPaiCheXiangQingData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.xiangQingPageNo = val
      this.getPaiCheXiangQingData()
    },
    // 查看
    handleClick (row) {
      this.title = '装车明细'
      this.seeMark = true
      yunDanGuanLiXiangQing({
        waybillNo: row.waybillNo
      }).then(res => {
        this.seetableList = res
      }).catch(err => {

      })
    },
    // 新增派车
    addPaiChe () {
      let params={
          planNo:''
      }
      params.planNo=this.rowData.planNo
      this.$router.push({ 
        name: 'dispatchCarAdd',
        params:params
      }) 
      // getManualDispatchCarInfo(params).then(res => {
      //   console.log(res)
      //   localStorage.setItem('params', JSON.stringify(res)) 
      //   this.$router.push({ name: 'dispatchCarAdd' })               
      //   // this.$router.push({
      //   //   name:'dispatchCarAdd',
      //   //   params:res
      //   // })
      // }).catch(err => {
      //   this.$message.error(err.message)
      // })
    },
    // 点击每行数据触发事件
    handleRowClick (row) {
      // console.log(row.waybillStatus, '22222222')
      this.$refs.paiCheXiangQingTab.toggleRowSelection(row)
      this.yunDanId = row.id
      this.waybillStatus = row.waybillStatus
      // 控制撤销派车按钮显示隐藏  多合同只有已派车状态能撤销
      // this.contractNos = row.contractNos.split(',')
      // if (this.contractNos.length > 1) {
      //   this.cheXiaoBtnShow = false
      // } else {
      //   this.cheXiaoBtnShow = true
      // }
      // 1已派车  2一检
      if (this.waybillStatus == '1') {
        this.cheXiaoBtnShow = true
      } else {
        this.cheXiaoBtnShow = false
      }
    },
    // 点击撤销派车
    cheXiaoClick () {
      let cheXiaoData = this.$refs.paiCheXiangQingTab.selection
      if (cheXiaoData.length < '1') {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.waybillStatus == '1') {
        this.cheXiaoMark = true
        this.title = '撤销原因'
      } else {
        this.$message.error('已派车状态可以撤销！')
        // 厂内一检完成和已派车可以撤销
      }
    },
    // 点击撤销原因确定
    cheXiaoQueDing () {
      if (this.cheXiaoYuanYin != '') {
        cheXiaoPaiChe({
          id: this.yunDanId,
          unsendcarReason: this.cheXiaoYuanYin
        }).then(res => {
          this.$message.success('撤销申请成功，请等待审核！')
          this.cheXiaoMark = false
          this.cheXiaoYuanYin = ''
          this.getPaiCheXiangQingData()
        }).catch(err => {
          this.$message.error(err.message)
        })
      } else {
        this.$message.error('请输入撤销原因！')
      }
    },
    // 点击撤销派车取消
    cheXiaoQuXiao () {
      this.cheXiaoMark = false
      this.cheXiaoYuanYin = ''
    },
    // 合计设置单位名称
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (column.label == '载重（吨）' ||
              column.label == '理重（吨）' ||
              column.label == '过磅重（吨）') {
            sums[index] = sums[index] + ' 吨'
          } else if (column.label == '完成率（%）') {
            sums[index] = sums[index] + ' %'
            // console.log(column,'0000')
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = '/'
        }
      })

      return sums
    },
    // 返回
    backClick () {
      this.$router.go(-1)
    },
    // 点击凭证
    seeImgClick(row){
      this.srcList2 = []
      receiptImg(row.id).then((res) =>{
        this.imgMark = true
        this.title = '查看凭证'
        let imageUrl = res.imageUrl
        this.srcList2.push(imageUrl)
      }).catch(err =>{
        this.$message.error(err.message)
      })
    },
    // 点击图片放大
    getSrcList2 (ix) {
      return this.srcList2.slice(ix).concat(this.srcList2.slice(0, ix))
    },
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  margin: 10px 0 0 -30px;

}
.titleText{
  margin-left: 10px;
}
 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.btn{
    width: 90px;
    // border: solid 1px;
    margin: 50px auto;
}
.red{
  color: red;
}
.green{
  color: green;
}
</style>
